import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  freeDescription: {
    defaultMessage: 'Ideal for quick label printing and basic shipping.',
    description: 'Description for the Free plan',
    id: 'h8Y+rM',
  },
  starterDescription: {
    defaultMessage: 'Perfect for small businesses to set up and manage their shipping operations.',
    description: 'Description for the Starter plan',
    id: 'veEmR2',
  },
  standardDescription: {
    defaultMessage: 'Designed for businesses needing more advanced capabilities that scale.',
    description: 'Description for the Standard plan',
    id: 'zOW34Q',
  },
  premiumDescription: {
    defaultMessage: 'Built for larger businesses managing complex shipping and logistics workflows.',
    description: 'Description for the Premium plan',
    id: 'ZGqQf/',
  },
});
